<!-- KEY -->
<svg
  *ngIf="!!uri && keyColumns[uri]"
  width="100%"
  height="100%"
  xmlns="http://www.w3.org/2000/svg"
  fit=""
  preserveAspectRatio="xMidYMid meet"
  matTooltip="This column is used as an identifier/key"
  matTooltipShowDelay="750"
>
  <path
    d="M16.5,14.25 L12,14.25 L12,11.25 L9.99,11.25 C9.135,13.065 7.29,14.25 5.25,14.25 C2.355,14.25 0,11.895 0,9 C0,6.105 2.355,3.75 5.25,3.75 C7.29,3.75 9.1275,4.935 9.99,6.75 L18,6.75 L18,11.25 L16.5,11.25 L16.5,14.25 Z M13.5,12.75 L15,12.75 L15,9.75 L16.5,9.75 L16.5,8.25 L8.955,8.25 L8.7825,7.7475 C8.2575,6.255 6.8325,5.25 5.25,5.25 C3.18,5.25 1.5,6.93 1.5,9 C1.5,11.07 3.18,12.75 5.25,12.75 C6.8325,12.75 8.2575,11.745 8.7825,10.2525 L8.955,9.75 L13.5,9.75 L13.5,12.75 Z M5.25,11.25 C4.0125,11.25 3,10.2375 3,9 C3,7.7625 4.0125,6.75 5.25,6.75 C6.4875,6.75 7.5,7.7625 7.5,9 C7.5,10.2375 6.4875,11.25 5.25,11.25 Z M5.25,8.25 C4.8375,8.25 4.5,8.5875 4.5,9 C4.5,9.4125 4.8375,9.75 5.25,9.75 C5.6625,9.75 6,9.4125 6,9 C6,8.5875 5.6625,8.25 5.25,8.25 Z"
  ></path>
</svg>

<!-- PACKAGE -->
<svg
  *ngIf="!!uri && (toggledAreSelected ? toggledColumns[uri] : !toggledColumns[uri])"
  width="100%"
  height="100%"
  xmlns="http://www.w3.org/2000/svg"
  fit=""
  preserveAspectRatio="xMidYMid meet"
>
  <path
    d="M15.405,3.9225 L14.3625,2.6625 C14.16,2.4075 13.8525,2.25 13.5,2.25 L4.5,2.25 C4.1475,2.25 3.84,2.4075 3.63,2.6625 L2.595,3.9225 C2.3775,4.1775 2.25,4.515 2.25,4.875 L2.25,14.25 C2.25,15.075 2.925,15.75 3.75,15.75 L14.25,15.75 C15.075,15.75 15.75,15.075 15.75,14.25 L15.75,4.875 C15.75,4.515 15.6225,4.1775 15.405,3.9225 Z M4.68,3.75 L13.32,3.75 L13.9275,4.4775 L4.08,4.4775 L4.68,3.75 Z M3.75,14.25 L3.75,6 L14.25,6 L14.25,14.25 L3.75,14.25 Z"
  ></path>
</svg>

<!-- FILTER -->
<svg
  *ngIf="!!uri && appliedFilters[uri]"
  width="100%"
  height="100%"
  xmlns="http://www.w3.org/2000/svg"
  fit=""
  preserveAspectRatio="xMidYMid meet"
>
  <path
    d="M11.2509919,14.91 C11.2809919,15.135 11.2059919,15.375 11.0334919,15.5325 C10.7409919,15.825 10.2684919,15.825 9.97599191,15.5325 L6.96849191,12.525 C6.79599191,12.3525 6.72099191,12.12 6.75099191,11.9025 L6.75099191,8.0625 L3.15849191,3.465 C2.90349191,3.1425 2.96349191,2.67 3.28599191,2.415 C3.42849191,2.31 3.58599191,2.25 3.75099191,2.25 L3.75099191,2.25 L14.2509919,2.25 L14.2509919,2.25 C14.4159919,2.25 14.5734919,2.31 14.7159919,2.415 C15.0384919,2.67 15.0984919,3.1425 14.8434919,3.465 L11.2509919,8.0625 L11.2509919,14.91 L11.2509919,14.91 Z M5.28099191,3.75 L8.25099191,7.545 L8.25099191,11.685 L9.75099191,13.185 L9.75099191,7.5375 L12.7209919,3.75 L5.28099191,3.75 Z"
  ></path>
</svg>
